var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 32,
    fill: "#27272A",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Mastercard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M26.233 9.673h6.842v12.295h-6.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.667 15.82a7.84 7.84 0 0 1 2.976-6.147A7.77 7.77 0 0 0 24.82 8 7.815 7.815 0 0 0 17 15.82a7.815 7.815 0 0 0 7.82 7.82c1.825 0 3.498-.63 4.823-1.672a7.81 7.81 0 0 1-2.976-6.148M42.308 15.82a7.815 7.815 0 0 1-7.82 7.82 7.77 7.77 0 0 1-4.823-1.672 7.78 7.78 0 0 0 2.976-6.148 7.84 7.84 0 0 0-2.976-6.147A7.77 7.77 0 0 1 34.487 8c4.323 0 7.82 3.52 7.82 7.82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Mastercard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 8h25.231v16H17z"
  })))));
};
export default SvgMastercard;